<template>
	<div>
		<div class="container">
			<div class="row">
				<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mx-auto">
					<div
						class="form--v10 px-3 py-4 px-md-5 py-md-6 rounded--10 bg-color--light--1"
					>
						<form class="form">
							<div
								class="alert alert-danger"
								role="alert"
								id="alert"
								v-show="alert"
							>
								<ul>
									<li v-for="err in errors" :key="err">
										{{ err[0] }}
									</li>
								</ul>
							</div>
							<div class="container">
								<div class="row">
									<div
										class="col-12 mx-auto color--white text-center mb-4 mb-lg-5"
									>
										<h4>
											{{ $t("ice.dentification") }}
										</h4>
									</div>
								</div>
								<div class="row">
									<div
										class="col-12 mx-auto color--white text-center mb-4 mb-lg-5"
									>
										<p>
											{{ $t("ice.description") }}
										</p>
									</div>
								</div>
								<div class="row justify-content-between">
									<div class="col-md-5">
										<div class="form-group">
											<label
													class="form__label text-uppercase font-size--15 font-w--500"
													>{{ $t("register.mobileNumber") }}</label
												>
												<input
													id="mobile_number"
													type="number"
													@wheel="$event.target.blur()"
													v-model.trim="$v.mobile_number.$model"
													class="form-control"
													:class="{ 'is-invalid': $v.mobile_number.$error }"
													@blur="$v.mobile_number.$touch()"
												/>
												<div class="invalid-feedback" v-if="!$v.mobile_number.required">
													ورود تلفن لازم است
												</div>
												<div
													class="invalid-feedback"
													v-if="!$v.mobile_number.minLength || !$v.mobile_number.maxLength"
												>
													شماره تلفن نا معتبر است
												</div>
										</div>
									</div>

									<!-- <div class="col-md-5">
										<div class="form-group">
											<label
												class="form__label text-uppercase font-size--15 font-w--500"
												>{{ $t("register.job") }}</label
											>
											<input
												id="job"
												type="text"
												
												class="form-control"
																								@blur="$v.job.$touch()"
											/> -->
									<!-- <div class="invalid-feedback" v-if="!$v.job.$required">
												عنوان شغلی خود را وارد کنید
											</div>
											<small id="" class="form-text text-danger">{{
												$t("register.jobDanger")
											}}</small>
										</div> -->
									<!-- </div> -->
								</div>
							</div>
						</form>
						<!-- end of form -->
					</div>
					<!-- end of from area -->
				</div>
				<!-- end of col -->
			</div>
			<!-- end of row -->
		</div>
	</div>
</template>

<script>
import { IceMixin } from "../mixins/validationMixin";

export default {
	data() {
		return {
			mobile_number:"",
			melli_code:"",
			status:""
		};
	},
	mixins: [IceMixin],

};
</script>
